import React from 'react'

export default function ViewerImgHandler() {
  return <div style={{ height: 33 }}></div>
}
